import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import EligibilityTimeline from "./EligibilityTimeline";

const CONFIG_COLOR = {
  confirmed: "success",
  needs_review: "warning",
  fail_open: "default",
  inactive: "default",
};

// One franchise in the triage list (franchise-grain: a franchise with several periods appears
// once). The configuration summary and the zero-or-more attention chips are independent — a
// confirmed franchise may still be flagged. Expanding reveals the franchise's timeline.
export default function EligibilityFranchiseRow({ franchise, onChanged }) {
  const [open, setOpen] = useState(false);

  const client =
    franchise.islilkickerclient === null || franchise.islilkickerclient === undefined
      ? "—"
      : franchise.islilkickerclient === 1
      ? "Yes"
      : "No";

  const periodParts = [];
  if (franchise.openConfirmedCount > 0) periodParts.push(`${franchise.openConfirmedCount} open`);
  if (franchise.closedConfirmedCount > 0) periodParts.push(`${franchise.closedConfirmedCount} closed`);
  if (franchise.confirmedCount === 0 && franchise.proposalCount > 0) {
    periodParts.push(`${franchise.proposalCount} proposed`);
  }
  const periodsLabel = periodParts.length ? periodParts.join(", ") : "—";

  const attentionChips = franchise.attention.map((a, i) => (
    <Tooltip key={i} title={a.note || ""}>
      <Chip size="small" color="warning" variant="outlined" label={a.label} sx={{ mr: 0.5 }} />
    </Tooltip>
  ));

  return (
    <>
      <TableRow hover sx={{ "& > *": { borderBottom: open ? "unset" : undefined } }}>
        <TableCell sx={{ width: 48 }}>
          <IconButton size="small" aria-label="expand franchise" onClick={() => setOpen((o) => !o)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{franchise.com_code}</TableCell>
        <TableCell>{franchise.franchise_name || "—"}</TableCell>
        <TableCell align="center">{client}</TableCell>
        <TableCell>
          <Chip
            size="small"
            label={franchise.configLabel}
            color={CONFIG_COLOR[franchise.configState] ?? "default"}
          />
        </TableCell>
        <TableCell>{attentionChips.length ? attentionChips : <Typography variant="body2" color="text.secondary">—</Typography>}</TableCell>
        <TableCell>{periodsLabel}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={7} sx={{ py: 0, borderBottom: open ? undefined : "none" }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ my: 1 }}>
              <EligibilityTimeline franchise={franchise} onChanged={onChanged} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
